import { FC } from "react";

import LimitationsManagementFeature from "src/features/limitations";

interface LimitationsManagementPageProps {
  match: {
    params: {
      crewId: string;
    };
  };
}

const LimitationsManagement: FC<LimitationsManagementPageProps> = ({ match }) => {
  return <LimitationsManagementFeature crewId={Number(match.params.crewId)} />;
};

export default LimitationsManagement;
